import React from 'react';
import { FormControl, Select, MenuItem, Box, OutlinedInput, InputAdornment } from '@mui/material';
import { Schedule } from '@mui/icons-material';
import { CustomWidthTooltipNoImage } from '../utils/customWidthToolTipUtilNoImage';

const TimeFilterDropdown = ({
  className = '',
  style = {},
  onChange,
  value = 'show-all'
}) => {
  const filterOptions = [
    { value: 'show-all', label: 'Time Filter', minutes: null },
    { value: '15min', label: '15 minutes', minutes: 15 },
    { value: '35min', label: '35 minutes', minutes: 35 },
    { value: '1hour', label: '1 hour', minutes: 60 },
    { value: '4hour', label: '4 hours', minutes: 240 },
    { value: '1day', label: '1 day', minutes: 1440 },
    { value: '1week', label: '1 week', minutes: 10080 }
  ];

  const toolTip = "Show alerts generated in the time selected.";

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <CustomWidthTooltipNoImage title={ toolTip } placement="top" dynamicWidth="250px" dyanmicHeight="25px" >
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <Select
              value={value}
              onChange={(e) => onChange && onChange(e.target.value)}
              className={className}
              input={
                <OutlinedInput
                  startAdornment={
                    <InputAdornment position="start">
                      <Schedule sx={{ color: '#cccccc', fontSize: 20 }} />
                    </InputAdornment>
                  }
                />
              }
              sx={{
                backgroundColor: '#2a2a2a',
                color: '#ffffff',
                height: '36px',
                fontSize: '0.875rem',
                fontWeight: 500,
                letterSpacing: '0.02em',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                borderRadius: '6px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#555555',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#777777',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#999999',
                },
                '& .MuiSelect-icon': {
                  color: '#cccccc',
                },
                '&:hover': {
                  backgroundColor: '#404040',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                },
                ...style
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: '#1a1a1a',
                    color: '#ffffff',
                    border: '1px solid #555555',
                    borderRadius: '8px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
                    backdropFilter: 'blur(10px)',
                    '& .MuiMenuItem-root': {
                      fontSize: '0.875rem',
                      fontWeight: 400,
                      py: 1,
                      '&:hover': {
                        backgroundColor: '#333333',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#666666',
                        '&:hover': {
                          backgroundColor: '#777777',
                        }
                      }
                    }
                  }
                }
              }}
            >
              {filterOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
      </CustomWidthTooltipNoImage>
    </Box>
  );
};

export default TimeFilterDropdown;
